"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NotificationItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* eslint-disable import/no-extraneous-dependencies */

const useStyles = (0, _styles.makeStyles)(theme => ({
  notificationBackground: {
    display: 'flex',
    width: 360,
    minHeight: 56,
    justifyContent: 'space-between',
    boxShadow: 'none'
  },
  notificationIcon: props => ({
    display: 'flex',
    minHeight: '100%',
    alignItems: props.children.length > 39 || props.content.length > 39 ? 'start' : 'center',
    justifyContent: props.children.length > 39 || props.content.length > 39 ? 'start' : 'center',
    paddingRight: 16,
    whiteSpace: 'break-spaces',
    color: theme.palette.primary.light,
    '& .MuiSvgIcon-root': {
      height: 48,
      width: 48
    }
  }),
  notificationBody: {
    width: '100%',
    paddingTop: 8,
    paddingBottom: 8,
    marginTop: 0
  },
  notificationBodyActive: {
    width: '100%',
    backgroundColor: '#E0E0E0',
    paddingLeft: 8,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.2)'
    }
  },
  activeIcon: props => ({
    color: '#FFB400',
    fontSize: 24,
    display: 'flex',
    maxWidth: '8px',
    minHeight: '100%',
    marginTop: props.children.length > 39 || props.content.length > 39 ? '13px' : '0',
    alignItems: props.children.length > 39 || props.content.length > 39 ? 'start' : 'center',
    justifyContent: props.children.length > 39 || props.content.length > 39 ? 'start' : 'center'
  }),
  textContainer: {
    whiteSpace: 'break-spaces'
  },
  timeContainer: {
    position: 'relative',
    left: 194,
    alignSelf: 'start'
  },
  timeContainerActive: {
    position: 'relative',
    left: 186,
    alignSelf: 'start'
  },
  content: {
    fontSize: 10
  }
}));
const NotificationItem = props => {
  const {
    children,
    content,
    icon,
    active,
    onClick
  } = props;
  const classes = useStyles(props);
  return /*#__PURE__*/_react.default.createElement(_core.Paper, {
    className: classes.notificationBackground,
    square: true
  }, /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    onClick: onClick,
    className: active ? classes.notificationBodyActive : classes.notificationBody
  }, active && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.activeIcon
  }, "\u2022"), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.notificationIcon
  }, icon), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "body2",
    className: classes.textContainer
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      fontSize: '14px'
    }
  }, children), content && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.content,
    color: "textSecondary"
  }, content))));
};
exports.NotificationItem = NotificationItem;
NotificationItem.propTypes = {
  children: _propTypes.default.string.isRequired,
  content: _propTypes.default.string.isRequired,
  icon: _propTypes.default.node.isRequired,
  active: _propTypes.default.bool.isRequired,
  onClick: _propTypes.default.func.isRequired
};
var _default = exports.default = NotificationItem;